// CRM-owned read-model helpers. No Profiles Admin Centre calls or database access.
export const PROFILE_SERVICE_ENDPOINT = '/api/services/profiles';

export function profileReferralEndpoint(status = 'open') {
  const safeStatus = ['open', 'in_progress', 'waiting_customer', 'resolved', 'closed', 'all'].includes(status) ? status : 'open';
  const parameters = new URLSearchParams({
    status: safeStatus,
    assigned_to: 'all',
    category: 'all',
    urgency: 'all',
    service: 'profiles',
  });
  return '/api/back-office/referrals?' + parameters.toString();
}

export function isActiveProfileSubscription(customer) {
  return ['active', 'trialing', 'current'].includes(String(customer?.subscription_status || '').toLowerCase());
}

export function searchProfileCustomers(customers, query) {
  const term = String(query || '').trim().toLowerCase();
  if (!term) return customers;
  return customers.filter(row => [
    row.display_name, row.customer_number, row.verified_email, row.plan_code,
    row.plan_name, row.canonical_plan_name, row.customer_id,
  ].some(value => String(value ?? '').toLowerCase().includes(term)));
}

export function normaliseProfilesService(data) {
  if (!Array.isArray(data?.customers)) throw new Error('Profiles service response did not include a customer register.');
  return data.customers;
}

export function normaliseProfilesReferrals(data) {
  if (!Array.isArray(data?.referrals)) throw new Error('Back Office did not return a referral register.');
  return data.referrals;
}

export function currentProfilesPlan(customer) {
  return String(customer?.canonical_plan_name || customer?.plan_name || customer?.plan_code || 'Unassigned').trim() || 'Unassigned';
}

export function profilesPlanSummary(customers) {
  const grouped = new Map();
  for (const row of customers) {
    const name = currentProfilesPlan(row);
    const current = grouped.get(name) || { name, customers: 0, active: 0 };
    current.customers += 1;
    if (isActiveProfileSubscription(row)) current.active += 1;
    grouped.set(name, current);
  }
  return [...grouped.values()].sort((a, b) => b.customers - a.customers || a.name.localeCompare(b.name));
}

export function filterProfilesByPlan(customers, selectedPlan) {
  if (!selectedPlan) return customers;
  return customers.filter(row => currentProfilesPlan(row) === selectedPlan);
}
